export default "__VITE_ASSET__67bf97b3__"